var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInitiative = function SvgInitiative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1761,
    height: 1445,
    viewBox: "-10 0 1761 1445"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m206 640 117-279q98-22 193-36 66-9 127-15l23-25-79-41 105-71 5-97L834 0q60 31 89 84 30 54 21 125t-57 134l-73-28-31 56q21 15 43 33 82 69 133 170l233-38-48-48 61-61 74 68 383-396 89-30-23 81-378 406 66 69-54 58-48-41-81 63-71-55-239 53-130-94-114 176 165 279 66 236 196 145H849l-137-277-163-261q-11 83-20 157-9 68-18 150l-130 71q-37-32-112.5-95.5T155 1094l-165 34 168-216q37 31 112.5 94.5T384 1102V714q92-143 168-262-33 1-51 3-50 3-97 7L293 676Z"
  })));
};
export default SvgInitiative;